import { mockComponent } from 'bloko/common/setupMockComponents';

export { default as StepwiseStep } from './StepwiseStep';

export default mockComponent('Stepwise', null, {
    withChildren: true,
});
